import {FormControl, InputLabel, MenuItem, Select} from '@mui/material';
import {TradeStatus, type Trade} from '@cp/model';

export interface SelectTradeStatusProps {
  data: Trade;
  setData: (next: Trade) => void;
}

export default function SelectTradeStatus({data, setData}: SelectTradeStatusProps) {
  return (
    <FormControl fullWidth size="small" sx={{gridColumn: {sm: '1 / -1'}}}>
      <InputLabel id={`status-${data.id}`}>Close type</InputLabel>
      <Select
        labelId={`status-${data.id}`}
        value={data.status}
        label="Close type"
        onChange={(e) => {
          const nextStatus = e.target.value as TradeStatus;
          setData({
            ...data,
            status: nextStatus,
            exitPrice: nextStatus === TradeStatus.OPEN ? 0 : data.exitPrice,
            closedAt: nextStatus === TradeStatus.OPEN ? 0 : data.closedAt,
            profitLoss: nextStatus === TradeStatus.OPEN ? 0 : data.profitLoss,
          });
        }}
      >
        <MenuItem value={TradeStatus.OPEN}>Open</MenuItem>
        <MenuItem value={TradeStatus.CLOSED}>Closed (manual)</MenuItem>
        <MenuItem value={TradeStatus.STOPLOSS}>Closed (stop loss)</MenuItem>
        <MenuItem value={TradeStatus.TAKEPROFIT}>Closed (take profit)</MenuItem>
      </Select>
    </FormControl>
  );
}
